import { render } from "./AuIcon.vue?vue&type=template&id=374ab56b&scoped=true"
import script from "./AuIcon.vue?vue&type=script&lang=js"
export * from "./AuIcon.vue?vue&type=script&lang=js"

import "./AuIcon.vue?vue&type=style&index=0&id=374ab56b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374ab56b"]])

export default __exports__